import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7208
 *
 * @param {SvgIconProps} props - svg props
 */
export const PlayCircleIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z' fill={color}/>
            <path d='M10.7846 8.04319C10.453 7.81361 10 8.05095 10 8.45428V15.5457C10 15.949 10.453 16.1864 10.7846 15.9568L15.9062 12.4111C16.1934 12.2123 16.1934 11.7877 15.9062 11.5889L10.7846 8.04319Z' fill='white'/>
        </SvgIcon>
    )
}

export default PlayCircleIcon
